/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllUserEnrolledCourse } from '../../../../services/operations/profileApi';
import Loading from '../../../../pages/Loading';
import ProgressBar from '@ramonak/react-progress-bar';
import { courseDuration } from '../../../../utils/courseDurationCount';
import { useNavigate } from 'react-router-dom';

const EnrolledCourses = () => {
    const dispatch = useDispatch();
    const { paymentLoading } = useSelector(state => state.course);
    const { user } = useSelector(state => state.profile);
    const [enrolledCoursesData, setEnrolledCoursesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const getAllEnrolledCoursesHandler = () => {
        dispatch(
            getAllUserEnrolledCourse(
                setEnrolledCoursesData, setLoading
            )
        );
    }
    const courseProgressHandler = (course) => {
        const totalLectures = course.courseContent
            ?.flatMap((section) => section.subSection)
            ?.reduce((accumulator) => accumulator + 1, 0) ?? 0;

        for (const item of user.courseProgresses) {
            if (item.courseId === course._id) {
                const completedVideos = item.completedVideos.length ?? 0;
                return (completedVideos / totalLectures) * 100;
            }
        }
    }
    useEffect(() => {
        getAllEnrolledCoursesHandler();
    }, []);

    if (loading || paymentLoading) {
        return <Loading />
    }

    return (
        <div className='text-richblack-5'>
            <div>
                <header className='text-[26px] font-semibold mb-5'>
                    Enrolled Courses
                </header>
                {
                    !enrolledCoursesData.length ? (
                        <p className='text-2xl font-bold text-center my-10'>
                            You have not enrolled in any course yet
                        </p>
                    ) : (
                        <div className='rounded-md overflow-hidden border border-richblack-700'>
                            <div className='flex justify-between bg-richblack-700 p-3'>
                                <p>Course Name</p>
                                <p className='w-[30%] md:text-end text-center'>
                                    Duration
                                </p>
                                <p className='w-[30%] md:block hidden'>
                                    Progress
                                </p>
                            </div>
                            <div className='px-3 mt-3 overflow-auto max-h-[calc(100vh-14rem)]'>
                                {enrolledCoursesData.map((enrolledCourse, index) => (
                                    <div
                                        onClick={() => {
                                            navigate(
                                                `/course/${enrolledCourse?.courseName.toLowerCase()}/${enrolledCourse?._id}/${enrolledCourse?.courseContent?.[0]?._id}/${enrolledCourse?.courseContent?.[0].subSection[0]}`)
                                        }}
                                        key={index}
                                        className='flex md:flex-row flex-col md:items-center justify-between border-b border-b-richblack-700 pb-3 cursor-pointer'
                                    >
                                        <div className='flex items-center md:w-[58%] justify-between'>
                                            <div className='flex enrolled-courses-title-and-thumbnail gap-x-3 w-[70%]'>
                                                <div className='w-[8rem] min-w-[8rem] min-h-[6rem] h-20 p-2'>
                                                    <img
                                                        src={enrolledCourse?.thumbnail}
                                                        alt={enrolledCourse?.courseName}
                                                        loading='lazy'
                                                        className='w-full h-full object-cover rounded-md'
                                                    />
                                                </div>
                                                <div className='flex flex-col gap-3 py-3 justify-center'>
                                                    <p>
                                                        {enrolledCourse?.courseName}
                                                    </p>
                                                    <p className='text-sm text-richblack-200'>
                                                        {enrolledCourse?.instructor?.firstName} {enrolledCourse?.instructor?.lastName}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className='md:w-[20%] w-[30%] text-center'>
                                                {courseDuration(enrolledCourse?.duration)}
                                            </div>
                                        </div>
                                        <div className='md:w-[30%] flex flex-col md:my-0 my-4 gap-1'>
                                            <p>
                                                Progress: {courseProgressHandler(enrolledCourse)?.toFixed(0)} %
                                            </p>
                                            <ProgressBar
                                                completed={courseProgressHandler(enrolledCourse)}
                                                height='10px'
                                                isLabelVisible={false}
                                                bgColor='#008080'
                                                borderRadius='1px'
                                            />
                                        </div>
                                    </div>
                                ))
                                }
                            </div>
                        </div>
                    )
                }
                <div></div>
            </div>
        </div>
    );
}

export default EnrolledCourses;